export default {
  default: () => import("/home/runner/work/Guest-Web/Guest-Web/layouts/default.vue").then(m => m.default || m),
  "no-footer": () => import("/home/runner/work/Guest-Web/Guest-Web/layouts/no-footer.vue").then(m => m.default || m)
}